module.exports = __webpack_public_path__ + "img/img-6.19f38a39.svg";